import { render } from "./Gameboard_PA.vue?vue&type=template&id=65e192de"
import script from "./Gameboard_PA.vue?vue&type=script&lang=js"
export * from "./Gameboard_PA.vue?vue&type=script&lang=js"

import "./Gameboard_PA.vue?vue&type=style&index=0&id=65e192de&lang=scss"
script.render = render

export default script